
import { useEffect } from 'react';

import { Responsive, scrollTop } from '@share/utils';
import { CarsDetailsWrapper } from '@components';

import './style.scss';

export function CarsDetailPage() {
  useEffect(() => {
    scrollTop();
  },[]);

  return (
    <div className="cars-details-page">
      <Responsive>
        <CarsDetailsWrapper />
      </Responsive>
    </div>
  );
}
